<template>
  <div>
    <v-navigation-drawer app class="dont-print-header" v-model="drawer">
      <v-list>
        <v-list-item class="px-2">
          <v-list-item-avatar height="90%" width="90%">
            <v-img
              alt="Vuetify Name"
              class="mt-1"
              contain
              :src="
                company.logo_path
                  ? `${mediaUrl + company.logo_path}`
                  : require('../../assets/mehfil-logo.jpg')
              "
              width="150"
              height="150"
            />
          </v-list-item-avatar>
        </v-list-item>
        <v-list-group no-action>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title class="text-h6">
                {{
                  user.first_name != null
                    ? user.first_name + " " + user.last_name
                    : user.email
                }}
              </v-list-item-title>
              <v-list-item-subtitle>{{
                roleName == "SUPER ADMIN" && company.id != null
                  ? "ADMIN"
                  : roleName
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </template>
          <v-list-item
            v-if="
              roleName == 'ADMIN' ||
              (roleName == 'SUPER ADMIN' && company.id != null)
            "
            :to="`/companies/${encryptIt(this.company.id)}`"
          >
            <v-list-item-title>Company</v-list-item-title>
          </v-list-item>
          <v-list-item to="/notifications" @click="hide_bell = true">
            <v-list-item-title>Notifications</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/profile/${encryptIt(user.id)}`">
            <v-list-item-title>My Profile</v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>
      <v-divider></v-divider>
      <v-list nav dense>
        <v-list-item
          :to="`/companies`"
          v-if="roleName == 'SUPER ADMIN' && company.id == null"
        >
          <v-list-item-icon>
            <v-icon>mdi-office-building-marker-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Companies</v-list-item-title>
        </v-list-item>
        <!-- User -->
        <v-list-group
          no-action
          :value="false"
          v-if="can('USERS.VIEW')"
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon size="25">mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="text-subtitle-1">Users</v-list-item-title>
          </template>
          <v-list-item :to="`/users`" v-if="can('USERS.VIEW')">
            <v-list-item-icon>
              <v-icon>mdi-table-of-contents </v-icon>
            </v-list-item-icon>
            <v-list-item-title>List</v-list-item-title>
          </v-list-item>
          <!-- <v-list-item :to="`/user-positions`">
            <v-list-item-icon>
              <v-icon>mdi-table-of-contents </v-icon>
            </v-list-item-icon>
            <v-list-item-title>User Positions</v-list-item-title>
          </v-list-item> -->
        </v-list-group>
        <!-- BD Member -->
        <v-list-group
          no-action
          :value="false"
          v-if="can('BD_MEMBERS.VIEW')"
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon size="25">mdi-account-group</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="text-subtitle-1"
              >BD Members</v-list-item-title
            >
          </template>
          <v-list-item :to="`/bd-members`" v-if="can('BD_MEMBERS.VIEW')">
            <v-list-item-icon>
              <v-icon>mdi-table-of-contents </v-icon>
            </v-list-item-icon>
            <v-list-item-title>List</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <!-- Agency -->
        <v-list-group
          no-action
          :value="false"
          v-if="can('AGENCIES.VIEW')"
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon size="25">mdi mdi-domain</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="text-subtitle-1"
              >Agency</v-list-item-title
            >
          </template>
          <v-list-item :to="`/agencies`" v-if="can('AGENCIES.VIEW')">
            <v-list-item-icon>
              <v-icon>mdi-table-of-contents</v-icon>
            </v-list-item-icon>
            <v-list-item-title>List</v-list-item-title>
          </v-list-item>
          <!-- <v-list-item :to="`/agency-members`">
            <v-list-item-icon>
              <v-icon>mdi-account-group</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Agency Staff</v-list-item-title>
          </v-list-item> -->
        </v-list-group>
        <!-- Room -->
        <v-list-group
          no-action
          :value="false"
          v-if="can('ROOMS.VIEW')"
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon size="25">mdi mdi-google-classroom</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="text-subtitle-1">Rooms</v-list-item-title>
          </template>
          <v-list-item :to="`/rooms`">
            <v-list-item-icon>
              <v-icon>mdi-table-of-contents </v-icon>
            </v-list-item-icon>
            <v-list-item-title>List</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/seat-configurations`" v-if="can('SEAT_CONFIGURATIONS.VIEW')">
            <v-list-item-icon>
              <v-icon>mdi-seat</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Seat Configurations</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <!-- Gift -->
        <v-list-group
          no-action
          :value="false"
          v-if="can('GIFTS.VIEW')"
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon size="25">mdi mdi-gift</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="text-subtitle-1">Gifts</v-list-item-title>
          </template>
          <v-list-item :to="`/gifts`" v-if="can('GIFTS.VIEW')">
            <v-list-item-icon>
              <v-icon>mdi-table-of-contents </v-icon>
            </v-list-item-icon>
            <v-list-item-title>List</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <!-- StoreItem -->
        <v-list-group
          no-action
          :value="false"
          v-if="can('STORE_ITEMS.VIEW')"
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon size="25">mdi-package-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="text-subtitle-1"
              >Store Items</v-list-item-title
            >
          </template>

          <v-list-item :to="`/store-items`" v-if="can('STORE_ITEMS.VIEW')">
            <v-list-item-icon>
              <v-icon>mdi-table-of-contents </v-icon>
            </v-list-item-icon>
            <v-list-item-title>List</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <!-- Chat -->
        <!-- <v-list-group
          no-action
          :value="false"
          v-if="
            roleName == 'ADMIN' ||
            (roleName == 'SUPER ADMIN' && company.id != null)
          "
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon size="25">mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="text-subtitle-1">Chats</v-list-item-title>
          </template>
          <v-list-item :to="`/chats`">
            <v-list-item-icon>
              <v-icon>mdi-table-of-contents </v-icon>
            </v-list-item-icon>
            <v-list-item-title>List</v-list-item-title>
          </v-list-item>
        </v-list-group> -->
        <!-- VIP Levels -->
        <v-list-group
          no-action
          :value="false"
          v-if="can('VIP_LEVELS.VIEW')"
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon size="25">mdi mdi-crown</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="text-subtitle-1"
              >VIP Levels</v-list-item-title
            >
          </template>
          <v-list-item :to="`/vip-levels`" v-if="can('VIP_LEVELS.VIEW')">
            <v-list-item-icon>
              <v-icon>mdi-format-list-numbered</v-icon>
            </v-list-item-icon>
            <v-list-item-title>List</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/vip-subscriptions`" v-if="can('VIP_SUBSCRIPTIONS.VIEW')">
            <v-list-item-icon>
              <v-icon>mdi-card-account-details-star</v-icon>
            </v-list-item-icon>
            <v-list-item-title>VIP Subscriptions</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/vip-privileges`" v-if="can('VIP_PRIVILEGES.VIEW')">
            <v-list-item-icon>
              <v-icon>mdi-card-account-details-star</v-icon>
            </v-list-item-icon>
            <v-list-item-title>VIP Privileges</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <!-- Levels -->
        <v-list-group
          no-action
          :value="false"
          v-if="can('LEVELS.VIEW')"
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon size="25">mdi mdi-stairs</v-icon>  
            </v-list-item-icon>
            <v-list-item-title class="text-subtitle-1"
              >Levels</v-list-item-title
            >
          </template>
          <v-list-item :to="`/levels`" v-if="can('LEVELS.VIEW')">
            <v-list-item-icon>
              <v-icon>mdi-format-list-bulleted</v-icon>
            </v-list-item-icon>
            <v-list-item-title>List</v-list-item-title>
          </v-list-item>
          <!-- <v-list-item :to="`/batch_medals`" v-if="can('BATCH_MEDALS.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-medal</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Batch Medals</v-list-item-title>
          </v-list-item> -->
        </v-list-group>
        <!-- Official Withdrawals -->
        <v-list-group
          no-action
          :value="false"
          v-if="can('OFFICIAL_WITHDRAWALS.VIEW')"
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon size="25">mdi-cash-minus</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="text-subtitle-1"
              >Official Withdrawals</v-list-item-title
            >
          </template>
          <v-list-item :to="`/official-withdrawals`" v-if="can('OFFICIAL_WITHDRAWALS.VIEW')">
            <v-list-item-icon>
              <v-icon>mdi-format-list-bulleted</v-icon>
            </v-list-item-icon>
            <v-list-item-title>List</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <!-- Rewards -->
        <v-list-group
          no-action
          :value="false"
          v-if="can('REWARDS.VIEW')"
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon size="25">mdi mdi-gift</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="text-subtitle-1"
              >Daily Rewards</v-list-item-title
            >
          </template>
          <v-list-item :to="`/rewards`" v-if="can('REWARDS.VIEW')">
            <v-list-item-icon>
              <v-icon>mdi-gift-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>List</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/user-rewards`" v-if="can('USER_REWARDS.VIEW')">
            <v-list-item-icon>
              <v-icon>mdi-account-star</v-icon>
            </v-list-item-icon>
            <v-list-item-title>User Rewards</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/weekly_room_rewards`" v-if="can('WEEKLY_ROOM_REWARDS.VIEW')">
            <v-list-item-icon>
              <v-icon>mdi-target</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Weekly Room Rewards</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <!-- Weekly Rewards -->
        <v-list-group
          no-action
          :value="false"
          v-if="can('WEEKLY_REWARDS.VIEW')"
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon size="25">mdi mdi-gift</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="text-subtitle-1"
              >Weekly Rewards</v-list-item-title
            >
          </template>
          <v-list-item :to="`/weekly-rewards`" v-if="can('WEEKLY_REWARDS.VIEW')">
            <v-list-item-icon>
              <v-icon>mdi-format-list-bulleted</v-icon>
            </v-list-item-icon>
            <v-list-item-title>List</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <!-- Reward Events -->
        <v-list-group
          no-action
          :value="false"
          v-if="can('REWARD_EVENTS.VIEW')"
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon size="25">mdi-calendar-star</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="text-subtitle-1"
              >Reward Events</v-list-item-title
            >
          </template>
          <v-list-item :to="`/reward-events`" v-if="can('REWARD_EVENTS.VIEW')">
            <v-list-item-icon>
              <v-icon>mdi-format-list-bulleted</v-icon>
            </v-list-item-icon>
            <v-list-item-title>List</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <!-- Recharge Agent -->
        <v-list-group
          no-action
          :value="false"
          v-if="can('COINSELLER_MERCHANTS.VIEW')"
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon size="25">mdi-calendar-star</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="text-subtitle-1"
              >Recharge Agent</v-list-item-title
            >
          </template>
          <v-list-item :to="`/coinseller-merchants`" v-if="can('COINSELLER_MERCHANTS.VIEW')">
            <v-list-item-icon>
              <v-icon>mdi-format-list-bulleted</v-icon>
            </v-list-item-icon>
            <v-list-item-title>List</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group
          no-action
          :value="false"
          v-if="canAny(['BANNERS.VIEW', 'ROOM_BACKGROUNDS.VIEW', 'POLICIES.VIEW', 'FEEDBACKS.VIEW', 'TICKETS.VIEW', 'RECHARGE_COINS.VIEW', 'RECHARGED_BENEFITS.VIEW', 'BADGES.VIEW', 'USER_BADGES.VIEW', 'USER_BLOCK_LISTS.VIEW', 'NOTIFICATIONS.VIEW', 'ROOM_NOTIFICATIONS.VIEW', 'GAME_LOGS.VIEW', 'MODULES.VIEW', 'PERMISSIONS.VIEW', 'VALUES.VIEW', 'POSITIONS.VIEW'])"
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon size="25">mdi-cogs</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="text-subtitle-1"
              >Settings</v-list-item-title
            >
          </template>

          <v-list-item :to="`/banners`" v-if="can('BANNERS.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-view-carousel</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Banners</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/room-backgrounds`" v-if="can('ROOM_BACKGROUNDS.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-view-carousel</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Room BackGrounds</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/policies`" v-if="can('POLICIES.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-file-document-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Policies</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/feedbacks`" v-if="can('FEEDBACKS.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-message-draw</v-icon>
            </v-list-item-icon>
            <v-list-item-title>FeedBacks</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/tickets`" v-if="can('TICKETS.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-ticket-account</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Support Tickets</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/recharge-coins`" v-if="can('RECHARGE_COINS.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-cash-plus</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Recharge Coins</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/rechargedbenefits`" v-if="can('RECHARGED_BENEFITS.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-gift-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Recharged Benefits</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/lucky-wheels`" v-if="can('LUCKY_WHEELS.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-ferris-wheel</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Lucky Wheels</v-list-item-title>
          </v-list-item>
          <!-- <v-list-item :to="`/lucky-wheels/spin`">
            <v-list-item-icon>
              <v-icon size="25">mdi-rotate-right</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Spin Wheel</v-list-item-title>
          </v-list-item> -->
          <v-list-item :to="`/badges`" v-if="can('BADGES.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-shield-star</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Badge</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/user-badges`" v-if="can('USER_BADGES.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-account-badge</v-icon>
            </v-list-item-icon>
            <v-list-item-title>User Badge</v-list-item-title>
          </v-list-item>

          <v-list-item :to="`/user-block-lists`" v-if="can('USER_BLOCK_LISTS.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-account-cancel</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Blacklist Users</v-list-item-title>
          </v-list-item>
          <!-- <v-list-item :to="`/diamond-exchanges`">
            <v-list-item-icon>
              <v-icon size="25">mdi-diamond-stone</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Diamond Exchanges</v-list-item-title>
          </v-list-item> -->
          <v-list-item :to="`/notifications`" v-if="can('NOTIFICATIONS.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-bell</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Notifications</v-list-item-title>
          </v-list-item>
          <!-- <v-list-item :to="`/profile-cards`">
            <v-list-item-icon>
              <v-icon size="25">mdi-card-account-details</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Profile Cards</v-list-item-title>
          </v-list-item> -->
          <v-list-item :to="`/room-notifications`" v-if="can('ROOM_NOTIFICATIONS.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-message-badge</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Room Notifications</v-list-item-title>
          </v-list-item>
          <!-- <v-list-item :to="`/transactions`">
            <v-list-item-icon>
              <v-icon size="25">mdi-bank-transfer</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Transactions</v-list-item-title>
          </v-list-item> -->
          <v-list-item :to="`/game-logs`" v-if="can('GAME_LOGS.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-gamepad-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Game Logs</v-list-item-title>
          </v-list-item>
          <!-- <v-list-item :to="`/posts`">
            <v-list-item-icon>
              <v-icon size="25">mdi-post</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Posts</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/post-comments`">
            <v-list-item-icon>
              <v-icon size="25">mdi-comment-multiple</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Post Comments</v-list-item-title>
          </v-list-item> -->

          <!-- <v-list-item :to="`/wallets`">
            <v-list-item-icon>
              <v-icon size="25">mdi-wallet</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Wallets</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/countries`">
            <v-list-item-icon>
              <v-icon size="25">mdi-earth</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Countries</v-list-item-title>
          </v-list-item> -->
          <v-list-item :to="`/modules`" v-if="can('MODULES.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-view-module</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Modules</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/permissions`" v-if="can('PERMISSIONS.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-key-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Permissions</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/values`" v-if="can('VALUES.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-format-list-checkbox</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Value</v-list-item-title>
          </v-list-item>
          <!-- <v-list-item :to="`/value-lists`">
    <v-list-item-icon>
      <v-icon size="25">mdi-format-list-text</v-icon>
    </v-list-item-icon>
    <v-list-item-title>ValueList</v-list-item-title>
  </v-list-item> -->
          <v-list-item :to="`/positions`" v-if="can('POSITIONS.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-map-marker</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Position</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/profile/${encryptIt(user.id)}`">
            <v-list-item-icon>
              <v-icon size="25">mdi-account-circle</v-icon>
            </v-list-item-icon>
            <v-list-item-title>My Profile</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-list-group no-action :value="false">
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon size="25">mdi-trash-can-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="text-subtitle-1">Trash</v-list-item-title>
          </template>

          <v-list-item :to="`/users?open_trash=true`">
            <v-list-item-icon>
              <v-icon size="25">mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Users</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/outlets?open_trash=true`">
            <v-list-item-icon>
              <v-icon size="25">mdi-store</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Outlets</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/pjps?open_trash=true`">
            <v-list-item-icon>
              <v-icon size="25">mdi-map-marker-path</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Pjps</v-list-item-title>
          </v-list-item>
          <v-list-group
            no-action
            sub-group
            :value="false"
            v-if="
              roleName == 'ADMIN' ||
              (roleName == 'SUPER ADMIN' && company.id != null)
            "
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Settings</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item :to="`/modules?open_trash=true`" link>
              <v-list-item-icon>
                <v-icon size="25">mdi-arrow-expand-all</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Modules</v-list-item-title>
            </v-list-item>
            <v-list-item :to="`/permissions?open_trash=true`" link>
              <v-list-item-icon>
                <v-icon size="25">mdi-arrow-expand-all</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Permissions</v-list-item-title>
            </v-list-item>
            <v-list-item :to="`/positions?open_trash=true`" link>
              <v-list-item-icon>
                <v-icon size="25">mdi-arrow-expand-all</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Position</v-list-item-title>
            </v-list-item>
          </v-list-group>
        </v-list-group>
        <v-list-item :to="`/user-timestamps`">
          <v-list-item-icon>
            <v-icon size="25">mdi-monitor-eye</v-icon>
          </v-list-item-icon>
          <v-list-item-title>User Timestamps</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar
      app
      color="white"
      class="dont-print-header"
      style="overflow-x: auto; overflow-y: hidden"
    >
      <v-app-bar-nav-icon
        variant="text"
        @click.stop="drawer = !drawer"
        color=""
      ></v-app-bar-nav-icon>
      <div class="d-flex align-center">
        <router-link to="/">
          <v-img
            alt="Vuetify Name"
            class="mt-1"
            contain
            min-width="50"
            :src="
              company.logo_path
                ? `${mediaUrl + company.logo_path}`
                : require('../../assets/mehfil-logo.jpg')
            "
            width="50"
            height="50"
        /></router-link>
      </div>
      &nbsp;
      <span class="my-auto" style="font-size: 25px; min-width: max-content">
        Hey,
        {{ user.user_name != null ? user.user_name : user.email }}
        {{ company.name ? "[ " + company.name + " ]" : "" }}
      </span>
      <v-container class="mt-5 ml-15" fluid v-if="roleName == 'SUPER ADMIN'">
        <v-switch
          inset
          @change="switch_to(company.id)"
          :loading="isSwitching"
          v-model="is_acting_admin"
          :label="`${is_acting_admin ? 'ADMIN' : 'SUPERADMIN'}`"
        ></v-switch>
      </v-container>
      <v-spacer></v-spacer>

      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <div v-if="hide_bell == false">
            <v-badge overlap color="pink" icon="mdi-bell">
              <v-avatar color="primary" v-bind="attrs" v-on="on">
                <v-icon dark> mdi-account-circle </v-icon>
              </v-avatar>
            </v-badge>
          </div>
          <div v-else>
            <v-avatar color="primary" v-bind="attrs" v-on="on">
              <v-icon dark> mdi-account-circle </v-icon>
            </v-avatar>
          </div>
        </template>
        <v-list dense>
          <v-list-item to="/notifications" @click="hide_bell = true">
            <v-list-item-title>Notifications</v-list-item-title>
          </v-list-item>
          <v-list-item
            :to="`/profile/${encryptIt(user.id)}`"
            @click="hide_bell = true"
          >
            <v-list-item-title>My Profile</v-list-item-title>
          </v-list-item>
          <v-list-item @click="logout">
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <router-view />
    <!-- Clear Success Dialog Box -->
    <v-dialog v-model="show_company_dialog" width="850">
      <v-card rounded="xxl">
        <v-card-title> <h1>Switch to Admin</h1> </v-card-title>
        <v-card-subtitle class="my-1">
          Please select the company whose admin portal you'd like to switch to.
        </v-card-subtitle>
        <v-card-text>
          <v-row>
            <v-col md="6">
              <v-text-field
                solo
                rounded
                v-model="form.search_keyword"
                label="Search ... "
                clearable
                color="#e60040"
                @click:clear="(form.search_keyword = null), getCompanies()"
                prepend-inner-icon="mdi-magnify"
                @keydown.enter="getCompanies"
                @change="page = 1"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-progress-linear
            v-if="isLoading"
            indeterminate
            color="primary"
          ></v-progress-linear>
          <v-row v-else>
            <v-col md="12">
              <v-simple-table fixed-header height="285" class="striped-table">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Sr No</th>
                      <th class="text-left">Status</th>
                      <th class="text-left" style="min-width: none">Name</th>
                      <th class="text-left">Email</th>
                      <th class="text-left">Admin Name</th>
                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="companies.length != 0">
                    <tr
                      v-for="(company, i) in companies"
                      :key="`company_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': companies.length - 1 == i,
                      }"
                    >
                      <td style="min-width: 85px">
                        {{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip bottom v-if="company.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>Company is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="company.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-cross-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Company is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>
                        <v-avatar rounded>
                          <v-img
                            alt="Vuetify Name"
                            class="mt-1"
                            contain
                            min-width="35"
                            :src="
                              company.logo_path
                                ? `${mediaUrl + company.logo_path}`
                                : require('../../assets/mehfil-logo.jpg')
                            "
                            width="35"
                            height="35"
                          />
                        </v-avatar>
                        &nbsp;
                        {{ company.name || "" }}
                      </td>
                      <td>{{ company.email || "" }}</td>
                      <td>{{ company.admin_name || "" }}</td>
                      <td class="text-right">
                        <v-btn
                          class="ml-2"
                          fab
                          x-small
                          color="primary"
                          @click="changeCompany(company.id)"
                        >
                          <v-icon dark> mdi-account-switch-outline </v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="7" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script type="text/javascript">
import { mapActions } from "vuex";
import axios from "axios";
import store from "@/store";

export default {
  data() {
    return {
      form: {
        search_keyword: "",
      },
      hide_bell: false,
      drawer: true,
      is_acting_admin: false,
      companyName: "",
      selectedCompanyId: "",
      company_data: {},
      companies: [],
      is_company_user: false,
      isLoading: false,
      isSwitching: false,
      show_company_dialog: false,
    };
  },
  mounted() {
    let company = store.getters["auth/company"];
    if (Object.keys(company).length > 0) {
      this.selectedCompanyId = company.id;
      if (this.roleName == "SUPER ADMIN") {
        this.is_acting_admin = true;
        console.log(this.is_acting_admin);
      }
      this.is_company_user = company ? true : false;
    }
  },
  methods: {
    ...mapActions({
      logOut: "auth/logOut",
    }),
    logout() {
      this.logOut();
      location.replace("/");
    },
    isActingAdmin() {
      let response = false;
      if (this.roleName == "SUPER ADMIN" && this.company.id != null) {
        response = true;
      }
      return response;
    },
    // Scroll back to the 1st validation error Message
    scrollToSection(selector) {
      // Example: smooth scroll to the specific section
      const element = document.querySelector(selector);
      const elementRect = element.getBoundingClientRect();
      const absoluteElementTop = elementRect.top + window.pageYOffset;
      const middle = absoluteElementTop - window.innerHeight / 2;
      window.scrollTo({
        top: middle,
        behavior: "smooth",
      });
      console.log(selector);
    },
    async getCompanies() {
      this.isLoading = true;
      this.form.search_keyword = this.form.search_keyword
        ? this.form.search_keyword
        : "";
      this.form.is_active = this.form.is_active ? this.form.is_active : "";
      let companies = [];
      let query =
        "search_keyword=" +
        this.form.search_keyword +
        "&is_active=" +
        this.form.is_active;
      companies = await axios.get(`companies?${query}`);
      this.companies = companies.data.data;
      this.count = companies.data.count;
      this.isLoading = false;
    },
    changeCompany(companyId) {
      this.selectedCompanyId = companyId;
      let company = this.companies.find((s) => s.id == this.selectedCompanyId);
      if (company) {
        console.log(company);
        store.dispatch("auth/setCompany", company);
        this.is_company_user = true;
      } else {
        store.dispatch("auth/setCompany", "");
        this.is_company_user = false;
      }
      window.location.href = "/auth/login";
      this.isSwitching = false;
      this.show_company_dialog = false;
      // this.$router.push("/auth/login");
    },
    switch_to(companyId = "") {
      this.isSwitching = true;
      console.log(this.is_acting_admin);
      if (this.is_acting_admin == true) {
        console.log("CompanyID " + companyId);
        console.log("Already SuperAdmin Switching to Admin");
        this.show_company_dialog = true;
      } else {
        console.log("Already Acting Admin Switching to SuperAdmin");
        this.selectedCompanyId = null;
        this.changeCompany();
      }
    },
  },
};
</script>
<style scoped>
.nav-text {
  text-decoration: none;
  color: black;
  font-weight: bold;
  font-size: 20px;
}

.v-application--is-ltr
  .v-list--dense.v-list--nav
  .v-list-group--no-action
  > .v-list-group__items
  > .v-list-item {
  padding: 0 8px 0 20px;
}
</style>
